/**
 * WordPress dependencies
 */
import {
	store,
	getContext,
	getElement,
	getConfig,
} from '@wordpress/interactivity';
import { emitEvent } from '../popper/frontend/utils';

const formSubmit = async () => {
	const { ref } = getElement();
	const context = getContext();
	const config = getConfig();
	const { id } = ref.dataset;
	const formData = new FormData( ref );
	formData.append( 'action', 'popper' );
	formData.append( '_nonce', config.nonce );
	formData.append( '_popper_id', id );

	try {
		context.isLoading = true;
		const req = await fetch( config.ajax_url, {
			method: 'POST',
			body: formData,
		} );

		const res = await req.json();
		context.response = res;

		context.isLoading = false;

		response( ref, res );
	} catch ( err ) {
		context.isLoading = false;
		if ( typeof err === 'string' || err instanceof String ) {
			context.response = { data: { message: err }, success: false };
		} else {
			context.response = {
				data: { message: 'An error occurred' },
				success: false,
			};
		}
	}
};

const response = ( ref, res ) => {
	const { data } = res;

	// Should we redirect?
	if ( data.redirect_url && res.success ) {
		window.location = data.redirect_url;
		return false;
	}

	// Should we hide form?
	if ( data.hide && res.success ) {
		const msg = ref.querySelector( '.popper-message' );
		ref.insertAdjacentElement( 'beforebegin', msg );
		setTimeout( () => {
			ref.style.display = 'none';
			msg.scrollIntoView( {
				behavior: 'smooth',
			} );
		}, '300' );
	}

	if ( data.debug && res.success ) {
		// eslint-disable-next-line no-console
		console.log( data.debug );
	}

	// clear form
	if ( res.success ) {
		emitEvent( 'form-success' );
		ref.reset();
	}
};

const { state } = store( 'popper', {
	state: {
		get debugData() {
			const context = getContext();
			return JSON.stringify( context.response.data.debug, undefined, 2 );
		},
		get message() {
			const context = getContext();


			if ( context.response?.data?.errors.length ) {
				return context.response?.data?.message;
			}

			return context.response && context.successMessage
				? context.successMessage
				: context.response?.data?.message;

		},
		get errors() {
			const context = getContext();
			return context.response?.data?.errors || [];
		},
	},
	actions: {
		sendForm: ( e ) => {
			e.preventDefault();
			e.stopPropagation();

			const context = getContext();

			context.isLoading = true;
			formSubmit( e );
		},
	},
} );
